<template>
  <b-card class="visitor-info-card" body-class="d-flex justify-content-center">
    <div class="w-100 d-flex flex-column align-items-center">
      <div class="d-flex justify-content-between">
        <span class="text-uppercase text-size-16 text-semibold-black">
          Self Check-in Information
        </span>
        <!-- <b-badge
          variant="light-success"
          pill
          class="d-flex justify-content-center align-items-center"
        >
          Check-in Successful
        </b-badge> -->
      </div>
      <!-- <div class="d-flex justify-content-center mt-2">
        <b-img
          :src="checkInInfo.imageIdentification"
          rounded
          class="visitor-img"
        />
      </div> -->
      <div
        class="checkin-success-box d-flex justify-content-center align-items-center mt-2"
      >
        <div
          class="check-icon-container d-flex justify-content-center align-items-center text-success bg-success"
        >
          <feather-icon icon="CheckIcon" size="18" class="text-white" />
        </div>
        <span class="text-success text-semibold-primary text-size-18"
          >Check-in Successful</span
        >
      </div>
      <div class="name-and-address text-center mt-1">
        <span class="d-block text-semibold-primary text-size-16">
          {{ `${checkInInfo.firstname} ${checkInInfo.lastname}` }}
        </span>
        <span
          class="d-block text-medium-grey text-uppercase custom-margin-top-8"
        >
          Identification Number
        </span>
        <span class="d-block text-semibold-black">
          {{
            getIdNumberDisplayFormat(checkInInfo.idType, checkInInfo.identity)
          }}
        </span>
        <!-- <span
          class="d-block text-medium-grey text-uppercase custom-margin-top-8"
        >
          Address
        </span>
        <span class="d-block text-semibold-black">
          {{ checkInInfo.address || "-" }}
        </span> -->
      </div>
      <!-- <div class="personal-info d-flex mt-2">
        <div class="nationality-box text-center px-2">
          <span class="d-block text-medium-grey text-uppercase">
            Nationality
          </span>
          <span class="d-block text-semibold-black custom-margin-top-8">
            {{ checkInInfo.nationality }}
          </span>
        </div>
        <div class="id-number-box text-center px-2">
          <span class="d-block text-medium-grey text-uppercase">
            Identification Number
          </span>
          <span class="d-block text-semibold-black custom-margin-top-8">
            {{
              getIdNumberDisplayFormat(checkInInfo.idType, checkInInfo.identity)
            }}
          </span>
        </div>
        <div class="expire-date-box text-center px-2">
          <span class="d-block text-medium-grey text-uppercase">
            Expire Date
          </span>
          <span class="d-block text-semibold-black custom-margin-top-8">
            {{
              customFormatDateTime(
                checkInInfo.expiredDate,
                "yyyy-MM-dd'T'HH:mm:ss",
                "dd LLL yyyy"
              )
            }}
          </span>
        </div>
      </div> -->
      <div class="d-flex justify-content-center">
        <div class="checkin-time-box text-center mt-2">
          <span class="d-block text-semibold-primary">
            Contact Staff for Access Card
          </span>
          <div>
            <span
              class="d-block text-medium-grey text-uppercase custom-margin-top-10"
            >
              Check-in At
            </span>
            <span class="d-block text-semibold-black custom-margin-top-2">
              {{
                setDateTimeFormat(checkInInfo.checkInDate, "dd LLL yyyy HH:mm")
              }}
            </span>
          </div>
          <div class="mt-1">
            <span
              class="d-block text-medium-grey text-uppercase custom-margin-top-8 mb-1"
            >
              Check-in For
            </span>
            <div
              class="row check-in-list"
              :class="{
                'flex-column align-items-center':
                  checkInInfo.selectedSiteAccesses.length <= 4,
              }"
            >
              <div
                v-for="(checkIn, index) in checkInInfo.selectedSiteAccesses"
                :key="index"
                class="col-6"
              >
                <div class="d-flex">
                  <div class="organization-name-container">
                    <span class="text-semibold-black">
                      {{ index + 1 }}. {{ checkIn.customerName }}
                    </span>
                  </div>
                  <span>&nbsp;({{ checkIn.siteAccessId }})</span>
                </div>
                <div class="text-left ml-1">
                  <span>
                    {{
                      customFormatDateTime(
                        checkIn.requestStartDate,
                        "yyyy-MM-dd'T'HH:mm:ss",
                        "dd LLL yyyy HH:mm"
                      )
                    }}
                    -
                    {{
                      customFormatDateTime(
                        checkIn.requestEndDate,
                        "yyyy-MM-dd'T'HH:mm:ss",
                        "dd LLL yyyy HH:mm"
                      )
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-3">
        <span class="text-color-grey text-size-12">
          Return to Homepage Automatically in
          <span class="text-color-black">{{ redirectTime }}</span>
        </span>
        <div class="d-flex justify-content-center">
          <atom-button
            buttonId="close-btn"
            class="close-btn-width mt-1"
            @click="clickCloseButton"
          >
            Close
          </atom-button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BBadge, BCard, BImg } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import mixinsDatetime from "@/mixins/mixinsDatetime"
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue"
export default {
  name: "MoleculeCheckInInfoCard",
  components: {
    BBadge,
    BCard,
    BImg,
    AtomButton,
    FeatherIcon,
  },
  mixins: [mixinsDatetime],
  props: {
    checkInInfo: {
      type: Object,
      required: true,
    },
    redirectTime: {
      type: Number,
      required: true,
    },
  },
  emits: ["onClickClose"],
  data() {
    return {
      defaultPicture: require("@/assets/images/avatars/10.png"),
    }
  },

  mounted() {},

  methods: {
    getIdNumberDisplayFormat(idType, idNumber) {
      if (idType === "idCard") {
        const separateIdNumber = [
          idNumber.slice(0, 1),
          idNumber.slice(1, 5),
          idNumber.slice(5, 11),
          idNumber.slice(11, 13),
          idNumber.slice(13),
        ]
        return separateIdNumber.join(" ")
      }
      return idNumber
    },

    clickCloseButton() {
      this.$emit("onClickClose")
    },
  },
}
</script>

<style lang="scss" scoped>
.visitor-info-card {
  padding: 12px;
  width: 900px;
}

.checkin-time-box {
  max-height: 350px;
  overflow-y: auto;
  width: 800px;
  border: 1px solid #d8d6de;
  border-radius: 6px;
  padding: 10px 40px;
}

.checkin-success-box {
  max-height: 250px;
  overflow-y: auto;
  width: 500px;
  background-color: rgba(40, 199, 111, 0.12);
  border-radius: 6px;
  padding: 20px 40px;
}

.nationality-box,
.id-number-box {
  border-right: 1px solid #d8d6de;
}

.visitor-img {
  border-radius: 6px;
  width: 128px;
  height: 160px;
  object-fit: cover;
}

.close-btn-width {
  width: 285px;
}

.organization-name-container {
  max-width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.check-icon-container {
  width: 24px;
  height: 24px;
  aspect-ratio: 1/1;
  border-radius: 9999px;
  margin-right: 8px;
}

.check-in-list {
  row-gap: 14px;
}
</style>
